import { getEnvVar } from "../util/env";

export const URL_PROD = getEnvVar("PUBLIC_HOST");
export const ASSETS_URL = getEnvVar("PUBLIC_ASSETS_URL");
export const IMAGES_URL = `${ASSETS_URL}/prod/assets/web/icons/`;

export const urlTerms = {
  termsConditions: "terminos-y-condiciones",
  policyData: "politica-de-proteccion-y-tratamiento-de-datos-personales",
  policyPrivacy: "politica-de-privacidad-de-datos-personales",
  termsConditionsNov: "terminos-y-condiciones-retention-12-Nov-2021",
  politcasDevolucion: "politica-de-cambios-y-devoluciones",
  blackweekSumer: "black-week-sumer-2021",
  regalo: "terminos-regalo-relampago",
  publicidad: "politicas-de-publicidad",
  cobra: "cobra-y-gana-con-Sumer",
};

/** URL única para el QR: debe redirigir a Play Store (Android) o App Store (iOS) según el dispositivo */
export const APP_DOWNLOAD_QR_URL = "https://play.google.com/store/apps/details?id=com.sumerlabs.sumer_app";

/** Página de compra de planes (Basic/Pro/Ultra). Destino del banner de catálogo bloqueado (blur). */
export const PREMIUM_URL = "https://domun.co/premium";

export const footerUrls = {
  downloadApp: "https://domun.co/rate",
  terms: `${URL_PROD}/terms/terminos-y-condiciones`,
  dataTreatment:
    `${URL_PROD}/terms/politica-de-privacidad-de-datos-personales`,
  logo: `${ASSETS_URL}/prod/assets/web/images/sumer-logo-black.png`,
  domunLogo: `${ASSETS_URL}/prod/assets/web/images/domun-logo.png`,
  landingGrowth: "https://link.domun.co/sDH5/web",
};

export enum PagesName {
  Terms = "terms",
}
